import React, {useCallback, useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography} from '@mui/material';
import {callApi} from 'utils';
import {formatDayparts} from 'utils/dayparts';

// Keep the submitted snapshot until the user confirms or cancels. A new save
// always goes through server preflight again, including after a stale response.
export default function useModeSave() {
  const [pending,setPending]=useState(null);
  const save=useCallback(async (url,method,data)=>{
    let snapshot=JSON.parse(JSON.stringify(data));
    for (;;) {
      const result=await callApi(url,method,snapshot);
      if (!result.confirmation_required) return result;
      const confirmed=await new Promise(resolve=>setPending({changes:result.mode_changes,resolve}));
      setPending(null);
      if (!confirmed) return null;
      snapshot={...snapshot,mode_confirmations:Object.fromEntries(result.mode_changes.map(change=>[change.id,change.token]))};
    }
  },[]);
  const close=()=>pending?.resolve(false);
  const dialog=(
    <Dialog open={Boolean(pending)} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle>确认切换任务模式</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          {pending?.changes.map(change=>(
            <Stack key={change.id} spacing={0.5}>
              <Typography>{change.id} · {change.name}</Typography>
              <Typography variant="body2">{formatDayparts(change.from_window,'–')}（{change.from_mode}） → {formatDayparts(change.to_window,'–')}（{change.to_mode}）</Typography>
            </Stack>
          ))}
          <Typography variant="body2">确认后保存本次修改并切换模式，历史排期保留。取消则不保存本次修改。</Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>取消</Button>
        <Button onClick={()=>pending.resolve(true)} variant="contained">确认切换并保存</Button>
      </DialogActions>
    </Dialog>
  );
  return {save,dialog};
}
